import React from 'react';
import PropTypes from 'prop-types';

import AsyncSelect from 'react-select/lib/Async';
//import Select from 'react-select';

import geocode from '../api/geocode';

const dropdownSelectStyle = {
    control: (base) => ({
        ...base,
        fontSize: '1rem',
        textAlign: 'left',
        border: '1px solid rgba(0,0,0,0.18)',
        borderRadius: 3,
        padding: 8,
        boxSizing: 'border-box',
        backgroundColor: '#FFFFFF',
    }),
};

const dropdownOptionItemStyle = {
    listSyle: 'none',
};

export default class Geocoder extends React.Component{
    constructor(props){
        super(props);
    }
    onSearchChange(searchTerm){
        return geocode(searchTerm).then((results) => {
            const newResults = results.map((result) => {
                return {
                    value: result.placeId,
                    label: result.formattedAddress,
                    location: result.location,
                    formattedAddress: result.formattedAddress,
                    bounds: result.bounds,
                    country: result.country,
                }
            });
            return newResults;
        });
    }
    onSelectChange(value){
        this.props.onResultSelect(value);
    }

    render(){
        return (
            <div style={{ position: 'relative' }} className="dropdown">
                <AsyncSelect
                    placeholder="Search Address"
                    isSearchable={true}
                    loadOptions={this.onSearchChange.bind(this)}
                    onChange={this.onSelectChange.bind(this)}
                    styles={dropdownSelectStyle} />
            </div>
        )
    }
}

Geocoder.propTypes = {
    onResultSelect: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/shared/components/Geocoder.js